import { Grid } from "@mui/material";
export function getLayoutBody(v, s) {
  return (
    <Grid container direction="row" spacing={4}>
      {v.map((t, i) => (
        <Grid item xs={12} lg={s[i]} key={`point${i}`} sx={{ width: `100%` }}>
          {t}
        </Grid>
      ))}
    </Grid>
  );
}
